import { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    nav: {
      status: "AVAILABLE — SHORT & LONG-TERM CONTRACTS, WORLDWIDE",
      links: [
        { n: "01", label: "Background", href: "#profilo" },
        { n: "02", label: "Skills", href: "#competenze" },
        { n: "03", label: "Gallery", href: "#galleria" },
        { n: "04", label: "Contact", href: "#contatti" },
      ],
      cta: "HIRE ME",
    },
    hero: {
      eyebrow: "// KORPSECUR — OPERATIONAL PROFILE",
      line1: "Military &",
      line2: "Private Security",
      sub: "A career built on discipline, precision, and sustained performance in the world's most demanding operational environments.",
      soldierFor: "Soldier for:",
      cta1: "VIEW DOSSIER",
      cta2: "SEND A WORK PROPOSAL",
      stats: [
        { value: "5+", label: "Years Operational" },
        { value: "FFL", label: "Foreign Legion" },
        { value: "CPO", label: "Close Protection" },
        { value: "Intl", label: "Multi-Theater" },
      ],
    },
    about: {
      eyebrow: "// ABOUT ME — OPERATIONAL PATH",
      titleA: "My",
      titleB: "background",
      stageLabel: "STAGE",
      timeline: [
        {
          n: "01",
          period: "5+ Years",
          title: "Légion Étrangère — 2e REP",
          body: "Five years of service in the French Foreign Legion as a combat infantryman, serving with 2e REP — one of the world's most elite paratroop regiments — and with 2e REI. A career built on discipline, precision and sustained performance in the most demanding operational theaters.",
          tags: ["Légion Étrangère", "2e REP", "2e REI", "Combat Infantryman"],
        },
        {
          n: "02",
          period: "Active Deployment",
          title: "Ukraine — Active Deployment",
          body: "Volunteer Combatant & Tactical Advisor. Deployed in one of the most demanding peer-adversary conflicts of the modern era. Managed high-intensity combat operations, coordinated defensive positions under direct fire, and adapted tactics in fast-moving, contested environments — demonstrating resilience and decisive leadership where it counts most.",
          tags: ["Volunteer Combatant", "Tactical Advisor", "Peer-Adversary Conflict"],
        },
        {
          n: "03",
          period: "Present",
          title: "Private Security — Independent Contractor",
          body: "Close Protection Officer & Security Advisor. Providing bespoke, discreet security solutions for high-net-worth individuals, corporate executives, diplomatic principals, and political figures — including active politicians and institutional representatives — across Europe, the Middle East, and Sub-Saharan Africa. Full operational lifecycle: threat assessment, advance work, route planning, and real-time principal protection.",
          tags: ["Close Protection Officer", "Security Advisor", "EU / ME / SSA"],
        },
      ],
      compTitle: "Core Competencies",
      compIntro: "Six field-proven areas of specialization, from close protection to intelligence.",
      competencies: [
        { t: "Close Protection Operations", d: "Advanced CPO protocols for HNWIs, executives, diplomatic principals, and political figures. Advance work, route planning, counter-surveillance." },
        { t: "Political & Institutional Security", d: "Specialized protection for politicians, government officials, and institutional figures. Protocol-aware planning and discreet escort." },
        { t: "Risk Assessment & Threat Analysis", d: "Structured methodology for evaluating environmental, geopolitical, and human threats. Intelligence-led planning with contingency frameworks." },
        { t: "Crisis Response & Management", d: "Trained response to kidnap, hostile contact, medical emergency, and civil unrest. Calm, decisive leadership under pressure." },
        { t: "High-Risk Environment Management", d: "Operational experience in active conflict zones and hostile urban environments. Logistics, extraction planning, and force protection." },
        { t: "Counter-Surveillance & Intelligence", d: "Detection and neutralization of surveillance efforts. Covert movement, pattern-of-life analysis, and HUMINT collection." },
      ],
      availTitle: "Availability",
      availBody: "Open to short and long-term engagements, with worldwide deployment capability. Discreet, professional, results-oriented: every mandate is planned, executed and closed to special-forces standards.",
      availTags: ["Short & Long-term", "Worldwide Deployment", "Full Discretion"],
      skills: [
        { label: "Close Protection", value: 100 },
        { label: "Risk Assessment", value: 100 },
        { label: "Crisis Management", value: 100 },
        { label: "Counter-Surveillance", value: 100 },
      ],
    },
    gallery: {
      eyebrow: "// VISUAL RECORD — DISCRETION MAINTAINED",
      titleA: "Operational",
      titleB: "Gallery",
      filters: [
        { id: "tutti", label: "All" },
        { id: "operazioni", label: "Operations" },
        { id: "urbano", label: "Urban" },
        { id: "squadra", label: "Team" },
        { id: "equipaggiamento", label: "Equipment" },
      ],
      photos: [
        { label: "Maritime Security", loc: "NAVAL SECTOR" },
        { label: "Combat Environment", loc: "URBAN AREA" },
        { label: "Equipment — Field Ready", loc: "OPERATING BASE" },
        { label: "Low Profile Loadout", loc: "GREY ZONE" },
        { label: "Convoy Operations", loc: "EASTERN THEATER" },
        { label: "Urban Deployment", loc: "RUINS SECTOR" },
        { label: "Desert Posture", loc: "DESERT SECTOR" },
        { label: "Operational Kit", loc: "ARMORY" },
        { label: "Field Operations", loc: "WOODLAND" },
        { label: "Operational Overwatch", loc: "OP HILLTOP" },
        { label: "Recon Patrol", loc: "GREEN ZONE" },
      ],
      classified: "CLASSIFIED",
      declassified: "DECLASSIFIED",
    },
    contact: {
      eyebrow: "// SECURE CHANNEL — JOB OFFERS",
      titleA: "Open a",
      titleB: "direct channel",
      infoLabels: ["Operational Email", "Direct Phone", "Instagram", "Operating Base"],
      baseValue: "Italy / Worldwide deployment",
      logTitle: "Messages received",
      logEmpty: "// NO TRANSMISSIONS LOGGED",
      secure: "ENCRYPTED CHANNEL ACTIVE",
      phName: "Full name *",
      phCompany: "Company / Organization",
      phEmail: "Email *",
      phPhone: "Phone",
      typeLabel: "Assignment type",
      types: ["VIP Close Protection", "Security Advisor", "Risk Assessment", "Training", "Other"],
      phMessage: "Describe your work proposal *",
      submit: "SEND TRANSMISSION",
      sending: "TRANSMITTING...",
      toastOk: "TRANSMISSION SENT SUCCESSFULLY",
      toastOkDesc: "Reply guaranteed within 24 hours.",
      toastMissing: "REQUIRED FIELDS MISSING",
      toastMissingDesc: "Name, email and proposal are required.",
      toastFail: "TRANSMISSION FAILED",
      toastFailDesc: "Retry or use the direct operational email.",
    },
    footer: {
      role: "Close Protection Officer & Security Advisor",
      disclaimer: "INFORMATION FOR PROFESSIONAL USE BY RECRUITERS AND SECURITY COMPANIES",
    },
  },
  it: {
    nav: {
      status: "DISPONIBILE — INCARICHI BREVI E LUNGHI, WORLDWIDE",
      links: [
        { n: "01", label: "Background", href: "#profilo" },
        { n: "02", label: "Competenze", href: "#competenze" },
        { n: "03", label: "Galleria", href: "#galleria" },
        { n: "04", label: "Contatti", href: "#contatti" },
      ],
      cta: "RECLUTAMI",
    },
    hero: {
      eyebrow: "// KORPSECUR — OPERATIONAL PROFILE",
      line1: "Military &",
      line2: "Private Security",
      sub: "Una carriera costruita su disciplina, precisione e performance costanti negli ambienti operativi più impegnativi al mondo.",
      soldierFor: "Soldier for:",
      cta1: "ESPLORA DOSSIER",
      cta2: "INVIA PROPOSTA LAVORATIVA",
      stats: [
        { value: "5+", label: "Anni Operativi" },
        { value: "FFL", label: "Foreign Legion" },
        { value: "CPO", label: "Close Protection" },
        { value: "Intl", label: "Multi-Theater" },
      ],
    },
    about: {
      eyebrow: "// CHI SONO — PERCORSO OPERATIVO",
      titleA: "Il mio",
      titleB: "background",
      stageLabel: "TAPPA",
      timeline: [
        {
          n: "01",
          period: "5+ Anni",
          title: "Légion Étrangère — 2e REP",
          body: "Cinque anni di servizio nella Légion Étrangère come fante da combattimento, nel 2e REP — uno dei reparti paracadutisti più élite al mondo — e nel 2e REI. Una carriera costruita su disciplina, precisione e performance sostenuta nei teatri operativi più impegnativi.",
          tags: ["Légion Étrangère", "2e REP", "2e REI", "Combat Infantryman"],
        },
        {
          n: "02",
          period: "Dispiegamento Attivo",
          title: "Ucraina — Dispiegamento Attivo",
          body: "Combattente Volontario & Consulente Tattico. Dispiegato in uno dei conflitti tra avversari paritari più impegnativi dell'era moderna. Gestione di operazioni di combattimento ad alta intensità, coordinamento di posizioni difensive sotto fuoco diretto e adattamento delle tattiche in ambienti contesi e in rapida evoluzione — resilienza e leadership decisiva dove conta di più.",
          tags: ["Volunteer Combatant", "Tactical Advisor", "Peer-Adversary Conflict"],
        },
        {
          n: "03",
          period: "Oggi",
          title: "Private Security — Independent Contractor",
          body: "Close Protection Officer & Security Advisor: soluzioni di sicurezza su misura e discrete per individui ad alto patrimonio, executive aziendali, personalità diplomatiche e figure politiche — inclusi politici in carica e rappresentanti istituzionali — in Europa, Medio Oriente e Africa Sub-Sahariana. Ciclo operativo completo: threat assessment, advance work, pianificazione dei percorsi e protezione del principal in tempo reale.",
          tags: ["Close Protection Officer", "Security Advisor", "EU / ME / SSA"],
        },
      ],
      compTitle: "Competenze Chiave",
      compIntro: "Sei aree di specializzazione consolidate sul campo, dalla protezione ravvicinata all'intelligence.",
      competencies: [
        { t: "Close Protection Operations", d: "Protocolli CPO avanzati per HNWI, executive, personalità diplomatiche e politiche. Advance work, pianificazione percorsi, controsorveglianza." },
        { t: "Political & Institutional Security", d: "Protezione specializzata per politici, funzionari governativi e figure istituzionali. Pianificazione attenta al protocollo e scorte discrete." },
        { t: "Risk Assessment & Threat Analysis", d: "Metodologia strutturata per valutare minacce ambientali, geopolitiche e umane. Pianificazione intelligence-led con piani di contingenza." },
        { t: "Crisis Response & Management", d: "Risposta addestrata a rapimenti, contatti ostili, emergenze mediche e disordini civili. Leadership calma e decisiva sotto pressione." },
        { t: "High-Risk Environment Management", d: "Esperienza operativa in zone di conflitto attivo e ambienti urbani ostili. Logistica, pianificazione di estrazione e force protection." },
        { t: "Counter-Surveillance & Intelligence", d: "Rilevamento e neutralizzazione di attività di sorveglianza. Movimento coperto, analisi pattern-of-life e raccolta HUMINT." },
      ],
      availTitle: "Disponibilità",
      availBody: "Aperto a incarichi di breve e lungo termine, con capacità di dispiegamento worldwide. Discreto, professionale, orientato ai risultati: ogni mandato viene pianificato, eseguito e chiuso con standard da reparto speciale.",
      availTags: ["Short & Long-term", "Worldwide Deployment", "Discrezione Totale"],
      skills: [
        { label: "Close Protection", value: 100 },
        { label: "Risk Assessment", value: 100 },
        { label: "Crisis Management", value: 100 },
        { label: "Counter-Surveillance", value: 100 },
      ],
    },
    gallery: {
      eyebrow: "// VISUAL RECORD — DISCRETION MAINTAINED",
      titleA: "Operational",
      titleB: "Gallery",
      filters: [
        { id: "tutti", label: "Tutti" },
        { id: "operazioni", label: "Operazioni" },
        { id: "urbano", label: "Urbano" },
        { id: "squadra", label: "Squadra" },
        { id: "equipaggiamento", label: "Equipaggiamento" },
      ],
      photos: [
        { label: "Sicurezza Marittima", loc: "SETTORE NAVALE" },
        { label: "Ambiente di Combattimento", loc: "AREA URBANA" },
        { label: "Equipaggiamento — Pronto", loc: "BASE OPERATIVA" },
        { label: "Loadout Low Profile", loc: "ZONA GRIGIA" },
        { label: "Operazioni di Convoglio", loc: "TEATRO EST" },
        { label: "Dispiegamento Urbano", loc: "SETTORE ROVINE" },
        { label: "Postura Desertica", loc: "SETTORE DESERTO" },
        { label: "Kit Operativo", loc: "ARMERIA" },
        { label: "Operazioni sul Campo", loc: "WOODLAND" },
        { label: "Osservazione Operativa", loc: "OP HILLTOP" },
        { label: "Pattuglia di Ricognizione", loc: "GREEN ZONE" },
      ],
      classified: "CLASSIFICATO",
      declassified: "DECLASSIFICATO",
    },
    contact: {
      eyebrow: "// CANALE SICURO — OFFERTE DI LAVORO",
      titleA: "Apri un",
      titleB: "canale diretto",
      infoLabels: ["Email Operativa", "Telefono Diretto", "Instagram", "Base Operativa"],
      baseValue: "Italia / Worldwide deployment",
      logTitle: "Messaggi ricevuti",
      logEmpty: "// NESSUNA TRASMISSIONE REGISTRATA",
      secure: "CANALE CRITTOGRAFATO ATTIVO",
      phName: "Nome completo *",
      phCompany: "Azienda / Organizzazione",
      phEmail: "Email *",
      phPhone: "Telefono",
      typeLabel: "Tipo di incarico",
      types: ["Close Protection VIP", "Security Advisor", "Risk Assessment", "Formazione", "Altro"],
      phMessage: "Descrivi la tua proposta di lavoro *",
      submit: "INVIA TRASMISSIONE",
      sending: "TRASMISSIONE IN CORSO...",
      toastOk: "TRASMISSIONE INVIATA CON SUCCESSO",
      toastOkDesc: "Risposta garantita entro 24 ore.",
      toastMissing: "CAMPI OBBLIGATORI MANCANTI",
      toastMissingDesc: "Nome, email e proposta sono richiesti.",
      toastFail: "TRASMISSIONE FALLITA",
      toastFailDesc: "Riprova o usa l'email operativa diretta.",
    },
    footer: {
      role: "Close Protection Officer & Security Advisor",
      disclaimer: "INFORMAZIONI AD USO PROFESSIONALE PER RECLUTATORI E AZIENDE DI SICUREZZA",
    },
  },
  fr: {
    nav: {
      status: "DISPONIBLE — MISSIONS COURTES ET LONGUES, DANS LE MONDE ENTIER",
      links: [
        { n: "01", label: "Parcours", href: "#profilo" },
        { n: "02", label: "Compétences", href: "#competenze" },
        { n: "03", label: "Galerie", href: "#galleria" },
        { n: "04", label: "Contact", href: "#contatti" },
      ],
      cta: "RECRUTEZ-MOI",
    },
    hero: {
      eyebrow: "// KORPSECUR — OPERATIONAL PROFILE",
      line1: "Military &",
      line2: "Private Security",
      sub: "Une carrière bâtie sur la discipline, la précision et une performance constante dans les environnements opérationnels les plus exigeants au monde.",
      soldierFor: "Soldat pour :",
      cta1: "EXPLORER LE DOSSIER",
      cta2: "ENVOYER UNE PROPOSITION",
      stats: [
        { value: "5+", label: "Années d'Opérations" },
        { value: "FFL", label: "Foreign Legion" },
        { value: "CPO", label: "Close Protection" },
        { value: "Intl", label: "Multi-Theater" },
      ],
    },
    about: {
      eyebrow: "// QUI SUIS-JE — PARCOURS OPÉRATIONNEL",
      titleA: "Mon",
      titleB: "parcours",
      stageLabel: "ÉTAPE",
      timeline: [
        {
          n: "01",
          period: "5+ Ans",
          title: "Légion Étrangère — 2e REP",
          body: "Cinq ans de service dans la Légion Étrangère comme fantassin de combat, au 2e REP — l'un des régiments parachutistes les plus élite au monde — et au 2e REI. Une carrière bâtie sur la discipline, la précision et une performance soutenue dans les théâtres opérationnels les plus exigeants.",
          tags: ["Légion Étrangère", "2e REP", "2e REI", "Fantassin de Combat"],
        },
        {
          n: "02",
          period: "Déploiement Actif",
          title: "Ukraine — Déploiement Actif",
          body: "Combattant Volontaire & Conseiller Tactique. Déployé dans l'un des conflits entre adversaires pairs les plus exigeants de l'ère moderne. Gestion d'opérations de combat de haute intensité, coordination de positions défensives sous le feu direct et adaptation des tactiques dans des environnements disputés en évolution rapide — résilience et leadership décisif là où cela compte le plus.",
          tags: ["Combattant Volontaire", "Conseiller Tactique", "Conflit Symétrique"],
        },
        {
          n: "03",
          period: "Aujourd'hui",
          title: "Private Security — Independent Contractor",
          body: "Close Protection Officer & Security Advisor : des solutions de sécurité sur mesure et discrètes pour des individus fortunés, des dirigeants d'entreprise, des personnalités diplomatiques et politiques — y compris des politiciens en exercice et des représentants institutionnels — en Europe, au Moyen-Orient et en Afrique subsaharienne. Cycle opérationnel complet : threat assessment, advance work, planification d'itinéraires et protection du principal en temps réel.",
          tags: ["Close Protection Officer", "Security Advisor", "EU / ME / SSA"],
        },
      ],
      compTitle: "Compétences Clés",
      compIntro: "Six domaines de spécialisation éprouvés sur le terrain, de la protection rapprochée au renseignement.",
      competencies: [
        { t: "Close Protection Operations", d: "Protocoles CPO avancés pour HNWI, dirigeants, personnalités diplomatiques et politiques. Advance work, planification d'itinéraires, contre-surveillance." },
        { t: "Political & Institutional Security", d: "Protection spécialisée pour hommes politiques, fonctionnaires et figures institutionnelles. Planification respectueuse du protocole et escortes discrètes." },
        { t: "Risk Assessment & Threat Analysis", d: "Méthodologie structurée pour évaluer les menaces environnementales, géopolitiques et humaines. Planification intelligence-led avec plans de contingence." },
        { t: "Crisis Response & Management", d: "Réponse entraînée aux enlèvements, contacts hostiles, urgences médicales et troubles civils. Leadership calme et décisif sous pression." },
        { t: "High-Risk Environment Management", d: "Expérience opérationnelle en zones de conflit actif et environnements urbains hostiles. Logistique, planification d'extraction et force protection." },
        { t: "Counter-Surveillance & Intelligence", d: "Détection et neutralisation des activités de surveillance. Mouvement couvert, analyse pattern-of-life et collecte HUMINT." },
      ],
      availTitle: "Disponibilité",
      availBody: "Ouvert aux missions de courte et longue durée, avec capacité de déploiement dans le monde entier. Discret, professionnel, orienté résultats : chaque mandat est planifié, exécuté et clôturé selon des standards de forces spéciales.",
      availTags: ["Short & Long-term", "Worldwide Deployment", "Discrétion Totale"],
      skills: [
        { label: "Close Protection", value: 100 },
        { label: "Risk Assessment", value: 100 },
        { label: "Crisis Management", value: 100 },
        { label: "Counter-Surveillance", value: 100 },
      ],
    },
    gallery: {
      eyebrow: "// VISUAL RECORD — DISCRETION MAINTAINED",
      titleA: "Operational",
      titleB: "Gallery",
      filters: [
        { id: "tutti", label: "Tous" },
        { id: "operazioni", label: "Opérations" },
        { id: "urbano", label: "Urbain" },
        { id: "squadra", label: "Équipe" },
        { id: "equipaggiamento", label: "Équipement" },
      ],
      photos: [
        { label: "Sécurité Maritime", loc: "SECTEUR NAVAL" },
        { label: "Environnement de Combat", loc: "ZONE URBAINE" },
        { label: "Équipement — Prêt", loc: "BASE OPÉRATIONNELLE" },
        { label: "Loadout Low Profile", loc: "ZONE GRISE" },
        { label: "Opérations de Convoi", loc: "THÉÂTRE EST" },
        { label: "Déploiement Urbain", loc: "SECTEUR RUINES" },
        { label: "Posture Désertique", loc: "SECTEUR DÉSERT" },
        { label: "Kit Opérationnel", loc: "ARMURERIE" },
        { label: "Opérations sur le Terrain", loc: "WOODLAND" },
        { label: "Observation Opérationnelle", loc: "OP HILLTOP" },
        { label: "Patrouille de Reconnaissance", loc: "GREEN ZONE" },
      ],
      classified: "CLASSIFIÉ",
      declassified: "DÉCLASSIFIÉ",
    },
    contact: {
      eyebrow: "// CANAL SÉCURISÉ — OFFRES DE MISSION",
      titleA: "Ouvrez un",
      titleB: "canal direct",
      infoLabels: ["Email Opérationnelle", "Téléphone Direct", "Instagram", "Base Opérationnelle"],
      baseValue: "Italie / Déploiement mondial",
      logTitle: "Messages reçus",
      logEmpty: "// AUCUNE TRANSMISSION ENREGISTRÉE",
      secure: "CANAL CRYPTÉ ACTIF",
      phName: "Nom complet *",
      phCompany: "Entreprise / Organisation",
      phEmail: "Email *",
      phPhone: "Téléphone",
      typeLabel: "Type de mission",
      types: ["Protection Rapprochée VIP", "Security Advisor", "Risk Assessment", "Formation", "Autre"],
      phMessage: "Décrivez votre proposition de mission *",
      submit: "ENVOYER LA TRANSMISSION",
      sending: "TRANSMISSION EN COURS...",
      toastOk: "TRANSMISSION ENVOYÉE AVEC SUCCÈS",
      toastOkDesc: "Réponse garantie sous 24 heures.",
      toastMissing: "CHAMPS OBLIGATOIRES MANQUANTS",
      toastMissingDesc: "Nom, email et proposition sont requis.",
      toastFail: "ÉCHEC DE LA TRANSMISSION",
      toastFailDesc: "Réessayez ou utilisez l'email opérationnel direct.",
    },
    footer: {
      role: "Close Protection Officer & Security Advisor",
      disclaimer: "INFORMATIONS À USAGE PROFESSIONNEL POUR RECRUTEURS ET ENTREPRISES DE SÉCURITÉ",
    },
  },
  es: {
    nav: {
      status: "DISPONIBLE — CONTRATOS CORTOS Y LARGOS, EN TODO EL MUNDO",
      links: [
        { n: "01", label: "Trayectoria", href: "#profilo" },
        { n: "02", label: "Competencias", href: "#competenze" },
        { n: "03", label: "Galería", href: "#galleria" },
        { n: "04", label: "Contacto", href: "#contatti" },
      ],
      cta: "RECLÚTAME",
    },
    hero: {
      eyebrow: "// KORPSECUR — OPERATIONAL PROFILE",
      line1: "Military &",
      line2: "Private Security",
      sub: "Una carrera construida sobre disciplina, precisión y rendimiento constante en los entornos operativos más exigentes del mundo.",
      soldierFor: "Soldado para:",
      cta1: "EXPLORAR DOSSIER",
      cta2: "ENVIAR PROPUESTA LABORAL",
      stats: [
        { value: "5+", label: "Años Operativos" },
        { value: "FFL", label: "Foreign Legion" },
        { value: "CPO", label: "Close Protection" },
        { value: "Intl", label: "Multi-Theater" },
      ],
    },
    about: {
      eyebrow: "// QUIÉN SOY — TRAYECTORIA OPERATIVA",
      titleA: "Mi",
      titleB: "trayectoria",
      stageLabel: "ETAPA",
      timeline: [
        {
          n: "01",
          period: "5+ Años",
          title: "Légion Étrangère — 2e REP",
          body: "Cinco años de servicio en la Legión Extranjera Francesa como infante de combate, en el 2e REP — uno de los regimientos paracaidistas más élite del mundo — y en el 2e REI. Una carrera construida sobre disciplina, precisión y rendimiento sostenido en los teatros operativos más exigentes.",
          tags: ["Légion Étrangère", "2e REP", "2e REI", "Infante de Combate"],
        },
        {
          n: "02",
          period: "Despliegue Activo",
          title: "Ucrania — Despliegue Activo",
          body: "Combatiente Voluntario y Asesor Táctico. Desplegado en uno de los conflictos entre adversarios equivalentes más exigentes de la era moderna. Gestión de operaciones de combate de alta intensidad, coordinación de posiciones defensivas bajo fuego directo y adaptación de tácticas en entornos disputados y de rápida evolución — resiliencia y liderazgo decisivo donde más importa.",
          tags: ["Combatiente Voluntario", "Asesor Táctico", "Conflicto Simétrico"],
        },
        {
          n: "03",
          period: "Actualidad",
          title: "Private Security — Independent Contractor",
          body: "Close Protection Officer y Security Advisor: soluciones de seguridad a medida y discretas para individuos de alto patrimonio, ejecutivos corporativos, personalidades diplomáticas y figuras políticas — incluidos políticos en activo y representantes institucionales — en Europa, Oriente Medio y África Subsahariana. Ciclo operativo completo: threat assessment, advance work, planificación de rutas y protección del principal en tiempo real.",
          tags: ["Close Protection Officer", "Security Advisor", "EU / ME / SSA"],
        },
      ],
      compTitle: "Competencias Clave",
      compIntro: "Seis áreas de especialización probadas sobre el terreno, desde la protección cercana hasta la inteligencia.",
      competencies: [
        { t: "Close Protection Operations", d: "Protocolos CPO avanzados para HNWI, ejecutivos, personalidades diplomáticas y políticas. Advance work, planificación de rutas, contravigilancia." },
        { t: "Political & Institutional Security", d: "Protección especializada para políticos, funcionarios gubernamentales y figuras institucionales. Planificación respetuosa con el protocolo y escoltas discretas." },
        { t: "Risk Assessment & Threat Analysis", d: "Metodología estructurada para evaluar amenazas ambientales, geopolíticas y humanas. Planificación intelligence-led con planes de contingencia." },
        { t: "Crisis Response & Management", d: "Respuesta entrenada a secuestros, contactos hostiles, emergencias médicas y disturbios civiles. Liderazgo calmado y decisivo bajo presión." },
        { t: "High-Risk Environment Management", d: "Experiencia operativa en zonas de conflicto activo y entornos urbanos hostiles. Logística, planificación de extracción y force protection." },
        { t: "Counter-Surveillance & Intelligence", d: "Detección y neutralización de actividades de vigilancia. Movimiento encubierto, análisis pattern-of-life y recolección HUMINT." },
      ],
      availTitle: "Disponibilidad",
      availBody: "Abierto a contratos de corta y larga duración, con capacidad de despliegue en todo el mundo. Discreto, profesional, orientado a resultados: cada mandato se planifica, ejecuta y cierra con estándares de fuerzas especiales.",
      availTags: ["Short & Long-term", "Worldwide Deployment", "Discreción Total"],
      skills: [
        { label: "Close Protection", value: 100 },
        { label: "Risk Assessment", value: 100 },
        { label: "Crisis Management", value: 100 },
        { label: "Counter-Surveillance", value: 100 },
      ],
    },
    gallery: {
      eyebrow: "// VISUAL RECORD — DISCRETION MAINTAINED",
      titleA: "Operational",
      titleB: "Gallery",
      filters: [
        { id: "tutti", label: "Todos" },
        { id: "operazioni", label: "Operaciones" },
        { id: "urbano", label: "Urbano" },
        { id: "squadra", label: "Equipo" },
        { id: "equipaggiamento", label: "Equipamiento" },
      ],
      photos: [
        { label: "Seguridad Marítima", loc: "SECTOR NAVAL" },
        { label: "Entorno de Combate", loc: "ZONA URBANA" },
        { label: "Equipamiento — Listo", loc: "BASE OPERATIVA" },
        { label: "Loadout Low Profile", loc: "ZONA GRIS" },
        { label: "Operaciones de Convoy", loc: "TEATRO ESTE" },
        { label: "Despliegue Urbano", loc: "SECTOR RUINAS" },
        { label: "Postura Desértica", loc: "SECTOR DESIERTO" },
        { label: "Kit Operativo", loc: "ARMERÍA" },
        { label: "Operaciones de Campo", loc: "WOODLAND" },
        { label: "Observación Operativa", loc: "OP HILLTOP" },
        { label: "Patrulla de Reconocimiento", loc: "GREEN ZONE" },
      ],
      classified: "CLASIFICADO",
      declassified: "DESCLASIFICADO",
    },
    contact: {
      eyebrow: "// CANAL SEGURO — OFERTAS DE TRABAJO",
      titleA: "Abre un",
      titleB: "canal directo",
      infoLabels: ["Email Operativo", "Teléfono Directo", "Instagram", "Base Operativa"],
      baseValue: "Italia / Despliegue mundial",
      logTitle: "Mensajes recibidos",
      logEmpty: "// NINGUNA TRANSMISIÓN REGISTRADA",
      secure: "CANAL CIFRADO ACTIVO",
      phName: "Nombre completo *",
      phCompany: "Empresa / Organización",
      phEmail: "Email *",
      phPhone: "Teléfono",
      typeLabel: "Tipo de encargo",
      types: ["Protección Cercana VIP", "Security Advisor", "Risk Assessment", "Formación", "Otro"],
      phMessage: "Describe tu propuesta de trabajo *",
      submit: "ENVIAR TRANSMISIÓN",
      sending: "TRANSMITIENDO...",
      toastOk: "TRANSMISIÓN ENVIADA CON ÉXITO",
      toastOkDesc: "Respuesta garantizada en 24 horas.",
      toastMissing: "FALTAN CAMPOS OBLIGATORIOS",
      toastMissingDesc: "Nombre, email y propuesta son obligatorios.",
      toastFail: "TRANSMISIÓN FALLIDA",
      toastFailDesc: "Inténtalo de nuevo o usa el email operativo directo.",
    },
    footer: {
      role: "Close Protection Officer & Security Advisor",
      disclaimer: "INFORMACIÓN DE USO PROFESIONAL PARA RECLUTADORES Y EMPRESAS DE SEGURIDAD",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("korp_lang") || "en");
  const setLang = (l) => {
    localStorage.setItem("korp_lang", l);
    setLangState(l);
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
